/**
 * 获取平台
 * @param req {node request}
 * @return {string}
 */
function getPlatform(req) {
  const deviceAgent = req.headers["user-agent"].toLowerCase()
  // const agentID = deviceAgent.match(/(iphone|ipod|ipad|android)/)
  const agentID = deviceAgent.match(/(iphone|ipod|android)/)
  if(agentID){
    // return 'h5' 這邊判斷很爛.....local時 註解掉 不然開啟 tools 會一直跳轉到h5
    return 'pc'
  }else{
    return 'pc'
  }
}

export default getPlatform
